export default {
      id: "common__warning-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "img/icons.svg#common__warning",
      toString: function () {
        return this.url;
      }
    }